module.exports = __webpack_public_path__ + "img/clothing108.92a79af7.jpg";